import { PvzFeature, TimetableStatus } from './types/types'

export const MIN_UPDATE_REASON_LENGTH = 30

export const enum PvzKeys {
  pvzModule = 'pvzModule',
  pvzPage = 'pvzModule.pvzPage',
  pvzItemPage = 'pvzModule.pvzItemPage',
  editTimetablePage = 'pvzModule.editTimetablePage',
  editAreaPage = 'pvzModule.editAreaPage',
  movingPage = 'pvzModule.movingPage',
  signboardPage = 'pvzModule.signboardPage',
}

export const timetableStatusTranslator: Record<TimetableStatus, string> = {
  [TimetableStatus.waiting]: 'Ожидает подтверждения',
  [TimetableStatus.approve]: 'Подтверждено',
  [TimetableStatus.reject]: 'Отклонено',
  [TimetableStatus.none]: '',
}

export const DEFAULT_PVZ_FEATURES: PvzFeature[] = [
  { label: 'Бокс для сдачи вещей', value: 'drop-off-boxes', checked: false },
  { label: 'Фандомат для бутылок', value: 'rvm', checked: false },
  { label: 'Контейнер для батареек', value: 'battery-container', checked: false },
  { label: 'Станция с зарядками', value: 'charging-station', checked: false },
  { label: 'Оборудование для воды', value: 'water-equipment', checked: false },
  { label: 'Кофейный аппарат', value: 'coffee-machine', checked: false },
  { label: 'Вендинговый аппарат', value: 'vending-machine', checked: false },
  { label: 'Раздельный сбор вторсырья', value: 'separate-recycling-collection', checked: false },
  { label: 'Сбор макулатуры', value: 'waste-paper-collection', checked: false },
  { label: 'Копировальные услуги', value: 'copy-services', checked: false },
]
